<template>
  <div>
    <template v-if="materiasOrden != undefined">
      <template v-if="materiasOrden.length > 0">
        <v-row no-gutters>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="9">
                <h2 class="titulo">Materia</h2>
              </v-col>
              <v-col cols="3">
                <h2 class="titulo">Orden</h2>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <template v-for="(materia, index) in materiasOrden">
          <v-row :key="index" class="materias" no-gutters>
            <v-col cols="12">
              <v-row no-gutters>
                <v-col cols="1" class="text-center">{{ index + 1 }} -</v-col>
                <v-col cols="8">{{ mayus(materia.nombre) }}</v-col>
                <v-col cols="2" class="text-center">
                  <input
                    :value="materia.orden"
                    class="order"
                    @change="
                      guardarOrdenMateria(
                        materia.idmateria_agrupamiento,
                        $event.target.value
                      )
                    "
                  />
                </v-col>
                <v-col cols="1" class="text-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        :class="[
                          materia.estado == '1'
                            ? 'quitar_materia_icono'
                            : 'agregar_materia_icono'
                        ]"
                        class="quitar_materia_icono"
                        v-on="on"
                        @click="
                          editarEstadoMateriaCurso(
                            materia.idmateria_agrupamiento,
                            materia.estado
                          )
                        "
                        >{{
                          materia.estado == 1
                            ? "mdi-minus-circle"
                            : "mdi-check-circle"
                        }}</v-icon
                      >
                    </template>
                    <span>{{
                      materia.estado == 1 ? "Quitar Materia" : "Agregar Materia"
                    }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </template>
      <template v-else style="text-align:center;">
        <h2>No hay materias asignadas a este curso.</h2>
      </template>
    </template>
  </div>
</template>

<script>
import API from "@/components/_config/conf";

export default {
  data() {
    return {
      materiasOrden: this.materias
    };
  },
  components: {},
  props: ["materias", "idAgrupamiento"],
  methods: {
    mayus(str) {
      let srt_result;

      if (str != "" && str != null) srt_result = API.ucFirst(str);
      else srt_result = str;
      return srt_result;
    },
    guardarOrdenMateria: function(idmateria_agrupamiento, orden) {
      if (orden != "") {
        let params = "idMateriaAgrupamiento=" + idmateria_agrupamiento;
        params += "&ordenMateriaAgrupamiento=" + orden;

        let resultado = API.enviar("get", "guardarOrdenMateria", params);

        resultado
          .then(result => {
            if (result.data.msj == "ok")
              this.$emit("curriculaOrden:recargarDatos", this.idAgrupamiento);
          })
          .catch(() => {});
      }
    },
    editarEstadoMateriaCurso: function(idMateriaAgrupamiento, estado) {
      let params = "idMateriaAgrupamiento=" + idMateriaAgrupamiento;
      params += "&estado=" + estado;

      let resultado = API.enviar("get", "editarEstadoMateriaCurso", params);

      resultado
        .then(result => {
          if (result.data.msj == "ok")
            this.$emit("curriculaOrden:recargarDatos", this.idAgrupamiento);
        })
        .catch(() => {});
    }
  },
  watch: {
    materias: function() {
      //console.log("watch materias: ", this.materias);
      this.materiasOrden = this.materias;
    }
  }
};
</script>

<style scoped>
.quitar_materia_icono {
  color: red;
}

.agregar_materia_icono {
  color: green;
}
</style>